import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import dateFormat from 'dateformat';

import {holidayCalendarSelector} from '@stencil/hotels-holiday-calendar-reducer/src/selectors';
import {getHolidayCalendarDataThunk} from '@stencil/hotels-holiday-calendar-reducer/src/thunks';
import HolidayCalenderLoader from '../../../verticals/hotels-dweb/src/stories/components/hotels/Loadingpage/HolidayCalenderLoader/HolidayCalenderLoader';
import * as S from './HolidayCalendar.styles';

var monthShortNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const trimHolidayCalendarDataForOlderFromList = (holidayCalendarData, dateConfig) => {
  const monthNumber = dateFormat(dateConfig, 'm');
  const year = dateFormat(dateConfig, 'yyyy');
  const retHolidayList = [];
  if (holidayCalendarData) {
    Object.entries(holidayCalendarData).map(([holidayYear, yearData]) => {
      if (holidayYear == year) {
        yearData.map((monthData, _) => {
          Object.entries(monthData).map(([monthIndex, _]) => {
            if (parseInt(monthIndex) >= parseInt(monthNumber) - 1) {
              retHolidayList.push(monthData);
            }
          });
        });
      }
    });
  }
  return retHolidayList;
};

export const HolidayCalendar = dateConfig => {
  const dispatch = useDispatch();

  const holidayCalendarDataSelector = useSelector(holidayCalendarSelector);
  const getHolidayCalendarDataThunkCaller = useCallback(() => {
    return dispatch(getHolidayCalendarDataThunk());
  }, [dispatch]);

  useEffect(() => {
    if (!holidayCalendarDataSelector) {
      getHolidayCalendarDataThunkCaller();
    }
  }, []);

  const parsedHolidayList = trimHolidayCalendarDataForOlderFromList(
    holidayCalendarDataSelector,
    dateConfig,
  );
  if (!holidayCalendarDataSelector) {
    return <HolidayCalenderLoader />;
  } else if (parsedHolidayList && parsedHolidayList.length > 0) {
    return (
      <S.HolidayCalenderWrapper>
        <S.HolidayCalenderHeader>Holiday Calendar</S.HolidayCalenderHeader>
        <S.HolidayCalenderListWrap>
          {parsedHolidayList.map((monthData, _) =>
            Object.entries(monthData).map(([monthIndex, monthHoliday]) =>
              monthHoliday.map((dateHoliday, _) =>
                Object.entries(dateHoliday).map(([holidayDate, holidayDetails]) => (
                  <S.HolidayListItem>
                    <S.CircularShape />
                    <S.HolidayListDate>
                      {parseInt(holidayDate)} {monthShortNames[monthIndex]}
                    </S.HolidayListDate>
                    <S.HolidayListFestival>{holidayDetails.name || ''}</S.HolidayListFestival>
                  </S.HolidayListItem>
                )),
              ),
            ),
          )}
        </S.HolidayCalenderListWrap>
      </S.HolidayCalenderWrapper>
    );
  }
  return null;
};
